/**
 * Convert placeholder name to readable label
 * e.g., "BROKER_NAME" -> "Broker Name"
 */
const placeholderToLabel = (placeholder) => {
  return placeholder
    .replace(/_/g, ' ') // Convert underscores to spaces first
    .split(/\s+/) // Split by any whitespace
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Dynamic form component for placeholder inputs
 */
const PlaceholderForm = ({ placeholders, formData, onChange, errors = {} }) => {
  const handleInputChange = (placeholder, value) => {
    onChange({
      ...formData,
      [placeholder]: value,
    });
  };

  return (
    <section className="form-section mb-4">
      <h2 className="font-semibold text-md mb-4 text-[#383838] dark:text-white">Fill Document Details</h2>

      <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4">
        {placeholders.map((placeholder) => {
          const label = placeholderToLabel(placeholder);
          const value = formData[placeholder] || '';
          const error = errors[placeholder];

          return (
            <div key={placeholder} className="flex flex-col">
              <label htmlFor={placeholder} className="block text-xs font-semibold text-[#383838] dark:text-[#A5A5A5] py-1">
                {label}
                <span className="text-xs text-red-500 ml-1">*</span>
              </label>

              <input
                id={placeholder}
                type="text"
                value={value}
                onChange={(e) => handleInputChange(placeholder, e.target.value)}
                className={`form-input ${error ? 'border-red-500' : 'border-[#F2F2F2]'}`}
                placeholder={`Enter ${label.toLowerCase()}`}
                maxLength={100}
              />

              <div className="flex justify-between mt-1">
                {error ? <span className="text-[10px] text-red-500">{error}</span> : <span />}
                <span className="text-[10px] text-gray-400">{value.length}/100</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 pt-6 border-t border-[#F2F2F2] dark:border-gray-700">
        <h2 className="font-semibold text-md mb-4 text-[#383838] dark:text-white">Seller Contact Details</h2>
        <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4">
          {['Name', 'Email', 'Phone Number'].map((field) => {
            const key = `seller_${field.toLowerCase().replace(/ /g, '_')}`;
            const value = formData[key] || '';
            const error = errors[key];
            let maxLength;
            if (field === 'Name') {
              maxLength = 50;
            } else if (field === 'Email') {
              maxLength = 100;
            } else {
              maxLength = 10;
            }

            let inputType = 'text';
            if (field === 'Email') {
              inputType = 'email';
            } else if (field === 'Phone Number') {
              inputType = 'tel';
            }

            return (
              <div key={key} className="flex flex-col">
                <label htmlFor={key} className="block text-xs font-semibold text-[#383838] dark:text-[#A5A5A5] py-1">
                  {field}
                  <span className="text-xs text-red-500 ml-1">*</span>
                </label>

                <input
                  id={key}
                  type={inputType}
                  value={value}
                  onChange={(e) => {
                    let newValue = e.target.value;
                    if (field === 'Phone Number') {
                      newValue = newValue.replace(/\D/g, '');
                    }
                    handleInputChange(key, newValue);
                  }}
                  className={`form-input ${error ? 'border-red-500' : 'border-[#F2F2F2]'}`}
                  placeholder={`Enter ${field.toLowerCase()}`}
                  maxLength={maxLength}
                />

                <div className="flex justify-between mt-1">{error ? <span className="text-[10px] text-red-500">{error}</span> : <span />}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PlaceholderForm;
